import type {TicketPriority} from '../types/ticket';

/**
 * The one place priority is named. Filters, quick filters, the queue's Priority
 * column, the legend and the detail panel all read from here, so a rename lands
 * everywhere at once and the filter menu can never disagree with the row it filters.
 */
export const PRIORITY_LABELS: Record<TicketPriority, string> = {
	p0: 'Urgent',
	p1: 'High',
	p2: 'Medium',
	p3: 'Low',
};

/** Most urgent first — the order priority is offered in every picker. */
export const PRIORITY_ORDER: readonly TicketPriority[] = ['p0', 'p1', 'p2', 'p3'];
